import { render, staticRenderFns } from "./MovementTextNotes.vue?vue&type=template&id=7ce03c64&"
import script from "./MovementTextNotes.vue?vue&type=script&lang=js&"
export * from "./MovementTextNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports